import { FinancialSnapshotType } from './template-type.enum';

export const FINANCIAL_ICON_MAPPING = {
  [FinancialSnapshotType.Income]: 'arrow-up-right',
  [FinancialSnapshotType.Expenses]: 'arrow-down-left',
  [FinancialSnapshotType.Liabilities]: 'cost-total',
  [FinancialSnapshotType.Assets]: 'piggy-bank',
};
